<div class="container h-100">
  <div class="row h-100 justify-content-center align-items-center text-center">

    <div class="col-12 col-xl-6 container container-wrapper">
      <form ngForm #form>
        <h3 class="pb-2">{{ 'Assign new password.' | translate }}</h3>
        <p>
          {{ 'The password must be at least 8 characters long, consists of uppercase and lowercase letters and at least one number.'| translate }}
        </p>
        <p></p>
        <app-input [title]='"Password" | translate' [name]="'password'" [type]='"password"' [(ngModel)]="password"
          appValidateEqual="repeatPassword" reverse="true" required #passwordRef="ngModel" appValidatePasswordPolicy>
        </app-input>
        <p></p>
        <p></p>
        <app-input [title]='"Repeat Password" | translate' [name]="'repeatPassword'" [type]='"password"'
          [(ngModel)]="repeatPassword" appValidateEqual="password" reverse="false" required #repeatPasswordRef="ngModel"
          appValidatePasswordPolicy></app-input>
        <p></p>

        <app-button [title]="'Change Password' | translate" (click)="onChangePassword(password, repeatPassword)"
          [buttonCssClass]="'button button-black button-right float-right'" [disabled]="!isFormValid || !token">
        </app-button>
      </form>
      <p class="error" *ngIf='error'>{{ error | translate }}</p>
    </div>
  </div>
</div>
